import styled from 'styled-components';

export const WidgetActions = styled.div`
  position: absolute;
  right: 34px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 5px;
`;

export const TableWrapper = styled.div`
  margin-top: 5px;
  flex-grow: 1;

  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const DimensionTableContainer = styled.div<{ width: number }>`
  flex-flow: wrap;
  flex-grow: 1;
  justify-content: space-between;
  height: fit-content;
  background-color: #e9edf0;
  margin: 2.5px;
  padding: 3px;
  box-sizing: border-box;
  margin-top: 0;
  overflow: hidden;
  width: auto;
  display: grid;
  grid-template-columns: ${(props) => `repeat(auto-fill,minmax(${props.width}px, 1fr))`};
  grid-auto-rows: 47px;
  gap: 10px;
`;

export const DimensionHeader = styled.div`
  /* display: flex; */
  margin: 20px 10px;
`;

export const DimensionNameWrapper = styled.div`
  display: inline-block;
  height: 32px;
  font-size: 14px;
  padding: 0 11px;
  color: rgb(0 0 0 / 25%);
  background: rgb(0 0 0 / 4%);
  width: 280px;
  background-color: #f8fafb;
  border-bottom: 1px solid #e5e9ec;
  border-right: 1px solid #e5e9ec;
  line-height: 31px;
  font-weight: 600;
  margin-top: -5px;
  margin-left: -10px;
`;

export const DimensionTableWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 5px 10px;
  box-sizing: border-box;
  flex-grow: 0;
  border-radius: 6px;
  height: 100%;

  &:hover {
    .remove-dimension-btn {
      opacity: 1;
    }

    .drag-handle {
      opacity: 1;
    }
  }
`;

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  height: 44px;
  background-color: #e5e5e5;
`;

export const RCASwitch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .rca-mode-text {
    margin: 0 16px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .rca-mode-status-text {
      font-weight: 600;
      margin-left: 4px;
    }
  }
`;

export const RCATitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  margin-left: 16px;
`;

export const InvalidIntervalContainer = styled.div`
  height: 200;
  margin: 20px 10px;
`;

export const RCATablesContainer = styled.div`
  position: relative;
  height: 500px;
  margin-top: 12px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;

  .BaseTable__row-cell {
    position: relative;

    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const RCANetworkRequsetNameContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const TraceIdItem = styled.div`
  width: 100%;
  flex-direction: row;
  align-items: center;
  display: flex;
  padding: 4px 0;
`;

export const HintCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HintTagWrapper = styled.div<{ color: string }>`
  display: flex;
  color: ${(props) => `${props.color}`};
  border-radius: 3px;
  border: solid 1px ${(props) => `${props.color}`};
  padding: 0 3px;
  font-size: 11px;
  box-sizing: border-box;
  margin-left: 8px;
  font-weight: 600;
`;

export const DrawerTitle = styled.div`
  width: 100%;
  height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
`;
